import {local} from 'wix-storage'

export async function wait(ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}

export function getElapsedTime () {
    let startTimeMili = local.getItem('startTime')
    let elapsedMili = Date.now() - parseInt(startTimeMili)
//   return moment(elapsedMili).fomat('mm:ss')
    let seconds = parseInt(elapsedMili % (1000*60) / 1000)
    if (seconds < 10){
        seconds = '0'+seconds
    }
    return startTimeMili ? parseInt(elapsedMili / (1000*60))+":"+seconds : '00:00'
}

export function useClue(){
    let usedClues = local.getItem('usedClues')
    let usedCluesInt = parseInt(usedClues)
    usedCluesInt++
    local.setItem('usedClues', usedCluesInt)
}


// The following code demonstrates how to call the add
// function from your site's page code or site code.

/* 
import {add} from 'public/utils.js'

$w.onReady(function () {	
    let sum = add(6,7);
    console.log(sum);
});
*/


//The following code demonstrates how to call the add 
//function in one of your site's backend files.

/* 
import {add} from 'public/utils.js'

export function usingFunctionFromPublic(a, b) {
	return add(a,b);
}
*/